import Vue from "vue";
import { MEETING_YEAR } from '@/common/index';

import VueRouter from "vue-router";

import store from "../store";

import InvitationLetter2024 from "@/pages/client/invitationLetterIndex";
import meetingStep from "@/pages/client/meetingStep";
import clientLogin from "@/pages/client/clientLogin";
import refuseInvitation from "@/pages/client/refuseInvitation";
import clientOperateResult from "@/pages/client/clientOperateResult";
import clientResult from "@/pages/client/clientResult";

import adminLogin from "@/pages/admin/adminLogin";
import managerMain from "@/pages/admin/managerMain";
import clientInformationForm from "@/pages/admin/clientInformationForm";
import invitationClientManage from "@/pages/admin/invitationClientManage";

// todo 获取旧的页面
import Question2023Stop from "@/pages/questionnaire2023/complete.vue";
import DuanWuStop from "@/pages/2022DuanWu/stop";

const timeRouting = `invitationLetter${MEETING_YEAR}`;

function question2023RedirectStop(to, from, next) {
  next("/invitationLetter2023");
}

/**
 * todo 2022 端午活动停止了
 * @param to
 * @param from
 * @param next
 */
function duanWu2022RedirectStop(to, from, next) {
  next("/invitationLetterIndex");
}

Vue.use(VueRouter);

let router = new VueRouter({
  mode: "history",
  linkActiveClass: "is-active",
  scrollBehavior(to) {
    if (to.hash) {
      return {
        selector: to.hash,
      };
    }
  },
  routes: [
    {
      path: "", // myProperties 默认容错口
      redirect: `/${timeRouting}`,
    },
    // todo  2024年策略会
    {
      path: "/admin",
      component: adminLogin,
      name: "adminLogin",
      meta: {
        title: "adminLogin",
        navTitle: "管理登录",
      },
    },
    {
      path: "/managerMain",
      component: managerMain,
      name: "managerMain",
      meta: {
        title: "managerMain",
        navTitle: "管理主页",
      },
      children: [
        {
          path: "/managerMain/clientInformationForm",
          component: clientInformationForm,
          name: "clientInformationForm",
          meta: {
            title: "clientInformationForm",
            navTitle: "用户登记信息查询",
          },
        },
        {
          path: "/managerMain/invitationClientManage",
          component: invitationClientManage,
          name: "invitationClientManage",
          meta: {
            title: "invitationClientManage",
            navTitle: "用户邀请名单管理",
          },
        },
        {
          path: "/managerMain/agendaImage",
          component: () => import('@/pages/admin/agendaImage'),
          name: "agendaImage",
          meta: {
            title: "agendaImage",
            navTitle: "议程图片设置",
          },
        },
        {
          path: "/managerMain/dataAggregation",
          component: () => import('@/pages/admin/dataAggregation'),
          name: "dataAggregation",
          meta: {
            title: "dataAggregation",
            navTitle: "数据汇总",
          },
        },
      ],
    },
    {
      path: `/${timeRouting}`,
      component: InvitationLetter2024,
      name: "invitationLetter2024",
      meta: {
        title: "invitationLetter2023",
        navTitle: "邀请函首页",
      },
    },
    {
      path: "/invitationLetterComplete2025",
      component: Question2023Stop,
      name: "invitationLetterComplete2025",
      meta: {
        title: "invitationLetterComplete2025",
        navTitle: "活动结束",
      },
    },
    {
      path: `/${timeRouting}/clientLogin`,
      name: "clientLogin2024",
      component: clientLogin,
      meta: {
        title: "clientLogin2024",
        navTitle: "用户登录",
      },
    },
    {
      path: `/${timeRouting}/meetingStep`,
      name: "meetingStep2024",
      component: meetingStep,
      meta: {
        title: "meetingStep2024",
        navTitle: "会议流程",
      },
    },
    {
      path: `/${timeRouting}/meetingResult`,
      name: "meetingResult2024",
      component: () => import('@/pages/client/meetingResult'),
      meta: {
        title: "meetingResult2024",
        navTitle: "会议结果",
      },
    },
    {
      path: `/${timeRouting}/clientOperateResult`,
      name: "clientOperateResult2024",
      component: clientOperateResult,
      meta: {
        title: "clientOperateResult2024",
        navTitle: "问卷登记",
      },
    },
    {
      path: `/${timeRouting}/clientResult`,
      name: "clientResult2024",
      component: clientResult,
      meta: {
        title: "clientResult2024",
        navTitle: "用户登记信息展示",
      },
    },
    {
      path: `/${timeRouting}/refuseInvitation`,
      name: "refuseInvitation2024",
      component: refuseInvitation,
      meta: {
        title: "refuseInvitation2024",
        navTitle: "不参会",
      },
    },
    // todo 2023 策略会
    {
      path: "/invitationLetter2024",
      component: Question2023Stop,
      name: "invitationLetter2023",
      meta: {
        title: "invitationLetter2023",
        navTitle: "邀请函首页",
      },
    },
    {
      path: "/invitationLetter2025",
      component: Question2023Stop,
      name: "invitationLetter2025",
      meta: {
        navTitle: "邀请函首页",
      },
    },
    {
      path: "/clientLogin",
      name: "clientLogin",
      meta: {
        title: "clientLogin",
        navTitle: "用户登录",
      },
      beforeEnter: question2023RedirectStop,
    },
    {
      path: "/meetingStep",
      name: "meetingStep",
      meta: {
        title: "meetingStep",
        navTitle: "会议流程",
      },
      beforeEnter: question2023RedirectStop,
    },
    {
      path: "/clientOperateResult",
      name: "clientOperateResult",
      meta: {
        title: "clientOperateResult",
        navTitle: "问卷登记",
      },
      beforeEnter: question2023RedirectStop,
    },
    {
      path: "/clientResult",
      name: "clientResult",
      meta: {
        title: "clientResult",
        navTitle: "用户登记信息展示",
      },
      beforeEnter: question2023RedirectStop,
    },
    {
      path: "/refuseInvitation",
      name: "refuseInvitation",
      meta: {
        title: "refuseInvitation",
        navTitle: "不参会",
      },
      beforeEnter: question2023RedirectStop,
    },
    // todo 2022 端午
    {
      path: "/invitationLetterIndex",
      component: DuanWuStop,
      name: "invitationLetterIndex",
      meta: {
        title: "invitationLetterIndex",
        navTitle: "端午活动",
      },
    },
    {
      path: "/giftCardStopIndex",
      name: "giftCardStopIndex",
      beforeEnter: duanWu2022RedirectStop,
    },
    {
      path: "/giftCardIndex",
      name: "giftCardIndex",
      beforeEnter: duanWu2022RedirectStop,
    },
    {
      path: "/giftCardLogin",
      name: "giftCardLogin",
      beforeEnter: duanWu2022RedirectStop,
    },
    {
      path: "/giftCardDetail",
      name: "giftCardDetail",
      beforeEnter: duanWu2022RedirectStop,
    },
    {
      path: "/giftCardInfo",
      name: "giftCardInfo",
      beforeEnter: duanWu2022RedirectStop,
    },
    {
      path: "*",
      name: "*",
      redirect: `/${timeRouting}`,
    },
  ],
});
router.beforeEach((to, from, next) => {
  let _host = window.location.host;
  //全局路由拦截
  document.title =
    to.name.includes("invitationLetterIndex") || to.name.includes("giftCard")
      ? "高毅资产"
      : `高毅资产${MEETING_YEAR}投资报告会`;
  if (_host === "surveytest.gyasset.com" || _host === "survey.gyasset.com") {
    // let authNames = [
    //   "refuseInvitation",
    //   "clientResult",
    //   "clientOperateResult",
    //   "meetingStep",
    //   "clientLogin",
    //   "invitationLetterIndex",
    //   "giftCardStopIndex",
    //   "giftCardIndex",
    //   "giftCardLogin",
    //   "giftCardDetail",
    //   "giftCardInfo",
    //   "invitationLetter2023",
    // ];
    // if (authNames.includes(to.name)) {
    //   // console.log("客户端拦截")
    //
    // } else {
    //   next({name: "invitationLetter2023"});
    // }
    next()
  } else if (_host === "resulttest.gyasset.com" || _host === "result.gyasset.com") {
    if(to.name === timeRouting){
      next({name: "adminLogin"});
    } else {
      next();
    }
  } else {
    // console.log(to.name)
    next();
  }
});
export default router;
